module.exports = __webpack_public_path__ + "static/media/circo2024_funambulismo.941723d2.webp";